<template>
    <div class='login-box'>
        <div class='login-box-logo'>
            <img src='https://server.cottongame.com/serverstore/service/logo.png' alt=''>
            <h3>CottonGame</h3>
        </div>
        <el-form :model='ruleForm' status-icon :rules='rules' ref='ruleForm' class='login-form'>
            <el-form-item prop='email'>
                <el-input size='medium' :placeholder="$t('login.enterEmail') || '请输入邮箱'"
                          v-model='ruleForm.email'></el-input>
            </el-form-item>
            <el-form-item prop='captcha'>
                <el-input size='medium' style='width: 65%' :placeholder="$t('login.enterVerifyCode') || '请输入验证码'"
                          v-model='ruleForm.captcha'
                          autocomplete='off' />
                &nbsp;&nbsp;<el-button type='text' :disabled='captcha.sendStatus' size='medium'
                                       @click='sendCaptchaByEmail' style='float: right'>
                {{ captcha.sendStatus ? `${captcha.resendTime}${$t('login.resendAfter') || '秒后重新获取'}` : $t('login.getVerifyCode') || '获取验证码'
                }}
            </el-button>
            </el-form-item>
            <el-form-item>
                <el-button size='medium' style='width: 100%' type='primary' @click='submitForm'>
                    {{ $t('login.login') || '登录' }}
                </el-button>
            </el-form-item>
            
            <el-divider content-position='center'>{{ $t('common.or') || '或者使用以下方式' }}</el-divider>
            <el-row :gutter='10'>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('login')">{{ $t('login.accountLogin') || '账号登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('phoneLogin')">{{ $t('login.phoneLogin') || '短信登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('register')">{{ $t('login.createAccount') || '创建账号' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('forgetPwd')">{{ $t('login.forgetPassword') || '忘记密码'
                        }}
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { loginApi } from '@/service/api/loginApi';
import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';
import { accountApi } from '@/service/api/accountApi';

export default defineComponent({
    name: 'EmailLogin',
    data() {
        let validateCaptcha = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterVerifyCode') || '请输入验证码'));
            } else {
                callback();
            }
        };
        let validateEmail = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('login.enterEmail') || '请输入邮箱'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                email: undefined,
                captcha: undefined
            },
            rules: {
                email: [
                    { validator: validateEmail, trigger: 'blur' }
                ],
                captcha: [
                    { validator: validateCaptcha, trigger: 'blur' }
                ]
            },
            captcha: {
                sendStatus: false,
                resendTime: 60,
                time: undefined
            }
        };
    },
    created() {
        if (localStg.get(EnumLocalStore.jwtTokenName)) {
            this.$router.push('/');
        }
    },
    methods: {
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // 判断是手机号还是账号
                    loginApi.loginByEmail(this.ruleForm).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('login.loginSuccess') || '登录成功');
                            // 进入首页
                            let data = result.data;
                            localStg.set(EnumLocalStore.jwtTokenName, data.token);
                            localStg.set('account', data.data.account);
                            localStg.set('userId', data.data.userId);
                            localStg.set('platformId', data.data.platformId);
                            this.$router.push('/');
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        sendCaptchaByEmail() {
            if (!this.ruleForm.email) {
                return;
            }
            accountApi.sendCaptchaByEmail({ email: this.ruleForm.email }).then(result => {
                if (result.code === 200) {
                    message.success(this.$t('login.codeSentToEmail') || '验证码已发送至您的邮箱！');
                    this.captcha.sendStatus = true;
                    this.captcha.time = setInterval(() => {
                        if (this.captcha.resendTime <= 1) {
                            clearInterval(this.captcha.time);
                            this.captcha.resendTime = 60;
                            this.captcha.sendStatus = false;
                        }
                        this.captcha.resendTime = this.captcha.resendTime - 1;
                    }, 1000);
                }
            });
        },
        skipPage(router) {
            this.$router.push(router);
        }
    }
});
</script>

<style lang='css'>
@import "../../assets/css/login.css";
</style>
